enum GridType {
  TABLE = 'table',
  CARD = 'card',
}

export default GridType
